module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/shield-background-69b5416886709e718454c75c61c7b1a4.webp";